import { render } from "./MainBtn.vue?vue&type=template&id=22b2b3b2&scoped=true"
import script from "./MainBtn.vue?vue&type=script&lang=js"
export * from "./MainBtn.vue?vue&type=script&lang=js"

import "./MainBtn.vue?vue&type=style&index=0&id=22b2b3b2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b2b3b2"]])

export default __exports__